/**
 * @generated SignedSource<<e6133ac001427299a7789118cf33c7df>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type EventCompetitionsPageQuery$variables = {
  slug: string;
};
export type EventCompetitionsPageQuery$data = {
  readonly eventBySlug: {
    readonly id: string;
    readonly slug: string;
    readonly title: string;
    readonly viewerCanEditCompetitions: boolean;
    readonly " $fragmentSpreads": FragmentRefs<"EventCompetitionsFragment">;
  } | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"CompetitionAutocompleteFragment">;
};
export type EventCompetitionsPageQuery = {
  response: EventCompetitionsPageQuery$data;
  variables: EventCompetitionsPageQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "slug"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "slug",
    "variableName": "slug"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v5 = {
  "alias": "viewerCanEditCompetitions",
  "args": [
    {
      "kind": "Literal",
      "name": "action",
      "value": "ADD_EVENT_COMPETITION"
    }
  ],
  "kind": "ScalarField",
  "name": "viewerCan",
  "storageKey": "viewerCan(action:\"ADD_EVENT_COMPETITION\")"
},
v6 = {
  "kind": "Literal",
  "name": "first",
  "value": 10
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isPrivate",
  "storageKey": null
},
v8 = [
  (v6/*:: as any*/)
],
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v10 = {
  "kind": "TypeDiscriminator",
  "abstractKey": "__isEntity"
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayName",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "imageThumbnail",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "EventCompetitionsPageQuery",
    "selections": [
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "CompetitionAutocompleteFragment"
      },
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "Event",
        "kind": "LinkedField",
        "name": "eventBySlug",
        "plural": false,
        "selections": [
          (v2/*:: as any*/),
          (v3/*:: as any*/),
          (v4/*:: as any*/),
          (v5/*:: as any*/),
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "EventCompetitionsFragment"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "EventCompetitionsPageQuery",
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "fields": [
              {
                "kind": "Literal",
                "name": "search",
                "value": null
              }
            ],
            "kind": "ObjectValue",
            "name": "filters"
          },
          (v6/*:: as any*/)
        ],
        "concreteType": "CompetitionConnection",
        "kind": "LinkedField",
        "name": "competitions",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "CompetitionEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Competition",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v2/*:: as any*/),
                  (v4/*:: as any*/),
                  (v3/*:: as any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": "competitions(filters:{\"search\":null},first:10)"
      },
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "Event",
        "kind": "LinkedField",
        "name": "eventBySlug",
        "plural": false,
        "selections": [
          (v2/*:: as any*/),
          (v3/*:: as any*/),
          (v4/*:: as any*/),
          (v5/*:: as any*/),
          (v7/*:: as any*/),
          {
            "alias": "viewerCanCreateEventFromCompetition",
            "args": [
              {
                "kind": "Literal",
                "name": "action",
                "value": "CREATE_EVENT"
              }
            ],
            "kind": "ScalarField",
            "name": "viewerCan",
            "storageKey": "viewerCan(action:\"CREATE_EVENT\")"
          },
          {
            "alias": "viewerCanUpdate",
            "args": [
              {
                "kind": "Literal",
                "name": "action",
                "value": "UPDATE_EVENT"
              }
            ],
            "kind": "ScalarField",
            "name": "viewerCan",
            "storageKey": "viewerCan(action:\"UPDATE_EVENT\")"
          },
          {
            "alias": null,
            "args": (v8/*:: as any*/),
            "concreteType": "EventCompetitionConnection",
            "kind": "LinkedField",
            "name": "competitions",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "EventCompetitionEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "EventCompetition",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v2/*:: as any*/),
                      {
                        "alias": "viewerCanDelete",
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "action",
                            "value": "REMOVE_EVENT_COMPETITION"
                          }
                        ],
                        "kind": "ScalarField",
                        "name": "viewerCan",
                        "storageKey": "viewerCan(action:\"REMOVE_EVENT_COMPETITION\")"
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "membersCanReadEvent",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Competition",
                        "kind": "LinkedField",
                        "name": "competition",
                        "plural": false,
                        "selections": [
                          (v2/*:: as any*/),
                          (v3/*:: as any*/),
                          (v4/*:: as any*/),
                          (v7/*:: as any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "thumbnail",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "shortDescription",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "CompetitionMembership",
                            "kind": "LinkedField",
                            "name": "membership",
                            "plural": false,
                            "selections": [
                              (v2/*:: as any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "entity",
                                "plural": false,
                                "selections": [
                                  (v9/*:: as any*/),
                                  (v10/*:: as any*/),
                                  (v11/*:: as any*/),
                                  (v12/*:: as any*/),
                                  (v2/*:: as any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "host",
                            "plural": false,
                            "selections": [
                              (v9/*:: as any*/),
                              (v10/*:: as any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "username",
                                "storageKey": null
                              },
                              (v11/*:: as any*/),
                              (v12/*:: as any*/),
                              (v2/*:: as any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": [
                                  {
                                    "kind": "Literal",
                                    "name": "first",
                                    "value": 8
                                  }
                                ],
                                "concreteType": "TaggableConnection",
                                "kind": "LinkedField",
                                "name": "tags",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "TagEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "Tag",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                          (v2/*:: as any*/),
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "name",
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": "tags(first:8)"
                              }
                            ],
                            "type": "Taggable",
                            "abstractKey": "__isTaggable"
                          },
                          {
                            "alias": null,
                            "args": [
                              {
                                "kind": "Literal",
                                "name": "first",
                                "value": 1
                              }
                            ],
                            "concreteType": "RewardConnection",
                            "kind": "LinkedField",
                            "name": "rewards",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "totalCount",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "RewardEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Reward",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v2/*:: as any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "kind",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "AmountRange",
                                        "kind": "LinkedField",
                                        "name": "amount",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "start",
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "end",
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": "rewards(first:1)"
                          }
                        ],
                        "storageKey": null
                      },
                      (v9/*:: as any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "cursor",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "PageInfo",
                "kind": "LinkedField",
                "name": "pageInfo",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "endCursor",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "hasNextPage",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": "competitions(first:10)"
          },
          {
            "alias": null,
            "args": (v8/*:: as any*/),
            "filters": null,
            "handle": "connection",
            "key": "EventCompetitionsFragment_competitions",
            "kind": "LinkedHandle",
            "name": "competitions"
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "16d48954a37b88f5f1982bf6c1ef72aa",
    "id": null,
    "metadata": {},
    "name": "EventCompetitionsPageQuery",
    "operationKind": "query",
    "text": "query EventCompetitionsPageQuery(\n  $slug: String!\n) {\n  ...CompetitionAutocompleteFragment\n  eventBySlug(slug: $slug) {\n    id\n    slug\n    title\n    viewerCanEditCompetitions: viewerCan(action: ADD_EVENT_COMPETITION)\n    ...EventCompetitionsFragment\n  }\n}\n\nfragment ActivityCardHostFragment on Entity {\n  __isEntity: __typename\n  username\n  ...EntityProfilePicFragment_49kWkb\n}\n\nfragment ActivityCardTagListFragment on Taggable {\n  __isTaggable: __typename\n  tags(first: 8) {\n    edges {\n      node {\n        id\n        name\n      }\n    }\n  }\n}\n\nfragment CompetitionAutocompleteFragment on Query {\n  competitions(first: 10, filters: {}) {\n    edges {\n      node {\n        id\n        title\n        slug\n      }\n    }\n  }\n}\n\nfragment CompetitionCardFooterFragment on Competition {\n  rewards(first: 1) {\n    totalCount\n    edges {\n      node {\n        ...RewardFragment\n        id\n      }\n    }\n  }\n}\n\nfragment CompetitionCardFragment on Competition {\n  id\n  slug\n  title\n  thumbnail\n  shortDescription\n  membership {\n    id\n    entity {\n      __typename\n      ...EntityProfilePicFragment_49kWkb\n      id\n    }\n  }\n  host {\n    __typename\n    ...ActivityCardHostFragment\n    id\n  }\n  ...ActivityCardTagListFragment\n  ...CompetitionCardFooterFragment\n}\n\nfragment EntityProfilePicFragment_49kWkb on Entity {\n  __isEntity: __typename\n  displayName\n  imageThumbnail\n}\n\nfragment EventCompetitionsFragment on Event {\n  id\n  slug\n  isPrivate\n  viewerCanCreateEventFromCompetition: viewerCan(action: CREATE_EVENT)\n  viewerCanUpdate: viewerCan(action: UPDATE_EVENT)\n  competitions(first: 10) {\n    edges {\n      node {\n        id\n        viewerCanDelete: viewerCan(action: REMOVE_EVENT_COMPETITION)\n        membersCanReadEvent\n        competition {\n          id\n          slug\n          title\n          isPrivate\n          ...CompetitionCardFragment\n        }\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment RewardFragment on Reward {\n  id\n  kind\n  amount {\n    start\n    end\n  }\n}\n"
  }
};
})();

(node as any).hash = "440a17276a7c5509e918040f8211980a";

export default node;
